import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { AmountInputBase, Separator as Separator_ } from '@root/shared/ui-kit'

import { TradingDropdown } from './trading-input-target-dropdown'

import type { TargetType } from '@root/entities/limit-order/model/limit-order'

type Props = {
  targetType: TargetType
  suffix: React.ReactNode
  value: string | number
  placeholder?: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onChangeTargetType: (value: TargetType) => void
}

export const TradingInputTarget: React.FC<Props> = ({
  suffix,
  value,
  targetType,
  placeholder = '0',
  onChange,
  onChangeTargetType,
}) => {
  const { t } = useTranslation()

  return (
    <Root>
      <TradingDropdown
        items={[
          {
            value: 'market-cap',
            label: t('trade.market-cap-short'),
          },
          {
            value: 'absolute',
            label: t('common.price'),
          },
        ]}
        value={targetType}
        onChange={(value) => onChangeTargetType(value)}
      />
      <Separator vertical />
      <InputBase
        decimalScale={6}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      <Suffix>{suffix}</Suffix>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: 65px 30px minmax(0, 1fr) 30px;

  border-radius: 10px;
  background: var(--appearanceA-7);
  height: 40px;
  padding: 3px 10px 3px 3px;

  align-items: center;
`

const InputBase = styled(AmountInputBase)`
  background: transparent;
  color: var(--text-12);

  border: none;
  outline: none;
  height: 100%;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`

const Suffix = styled.span``

const Separator = styled(Separator_)`
  margin-inline-start: 15px;
`
